<template>
    <div>
        <transfer-payment-method
            :payment="payment"
            class="mt-2"
        ></transfer-payment-method>
    </div>
</template>

<script>
import TransferPaymentMethod from './TransferPaymentMethod'

export default {
    props: {
        payment: {
            type: Object,
        },
    },

    components: {
        TransferPaymentMethod,
    },
}
</script>
